import { Button } from "@/components/ui/button";
import { previousAppPath } from "@/lib/app-path-trail";
import { cn } from "@/lib/utils";
import { ArrowLeft, ArrowRight } from "lucide-react";
import { useLocation } from "wouter";

type Props = {
  fallbackHref?: string;
  label?: string;
  className?: string;
  /** icon = round control; chip = labeled button */
  variant?: "icon" | "chip";
  /** Header is LTR · use a left chevron there. */
  arrow?: "rtl" | "ltr";
  /** Sign-in and register show this on desktop too. */
  alwaysVisible?: boolean;
};

export function useNavigateBack(fallbackHref = "/") {
  const [location, setLocation] = useLocation();

  return () => {
    setLocation(previousAppPath(location, fallbackHref));
  };
}

/** Phone-only control to leave the current page without a popup. */
export function MobileBackButton({
  fallbackHref = "/",
  label = "رجوع",
  className,
  variant = "icon",
  arrow = "rtl",
  alwaysVisible = false,
}: Props) {
  const goBack = useNavigateBack(fallbackHref);
  const Arrow = arrow === "ltr" ? ArrowLeft : ArrowRight;
  const visibility = alwaysVisible ? "" : "md:hidden";

  if (variant === "chip") {
    return (
      <Button
        type="button"
        variant="outline"
        size="sm"
        onClick={goBack}
        className={cn(
          "h-9 gap-1.5 rounded-full border-neutral-200 bg-white px-3 text-sm font-medium text-[#1a1a19] shadow-sm",
          visibility,
          className,
        )}
        aria-label={label}
      >
        <Arrow className="size-4" />
        {label}
      </Button>
    );
  }

  return (
    <button
      type="button"
      onClick={goBack}
      className={cn(
        "flex size-9 shrink-0 items-center justify-center rounded-full border border-neutral-200 bg-white text-[#1a1a19] shadow-sm transition-colors hover:bg-neutral-50",
        visibility,
        className,
      )}
      aria-label={label}
    >
      <Arrow className="size-4" />
    </button>
  );
}
